var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgL4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M445.333 531.427L205.714 201.713L150.857 402.823L215.238 488.686L452.19 544.783L853.714 218.886V175H577.905L445.333 531.427Z",
    fill: "#06A2ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M414.476 524.558L104 469.605V603.933H393.143L414.476 524.558Z",
    fill: "#06A2ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M492.571 615L504.381 490.976L882.286 374.584L896 481.054L492.571 615Z",
    fill: "#06A2ED"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M445.333 531.427L205.714 201.713L150.857 402.823L215.238 488.686L452.19 544.783L853.714 218.886V175H577.905L445.333 531.427Z",
    stroke: "black",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M414.476 524.558L104 469.605V603.933H393.143L414.476 524.558Z",
    stroke: "black",
    strokeWidth: 3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M492.571 615L504.381 490.976L882.286 374.584L896 481.054L492.571 615Z",
    stroke: "black",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgL4);
export default __webpack_public_path__ + "static/media/l4.38f2c968a4512014335fcb9dbe84eee3.svg";
export { ForwardRef as ReactComponent };